<template lang="pug">
.new-product
  shForm(title="Nuevo Producto")
</template>

<script>
import shForm from '@/components/pages/product/Form'

export default {
  name: 'NewProduct',

  components: { shForm }
}
</script>

<style lang="stylus">
.new-product
  position relative
</style>



// WEBPACK FOOTER //
// src/components/pages/product/New.vue